import { API } from '../Api';

// Cấu hình công khai (feature flags...) — FE đọc để ẩn/hiện lối vào tính năng.
const base = '/v1/payment-service/system';

// Trả { "feature.reels": "true", ... }
export const getPublicSettings = () =>
  API.get<Record<string, string>>(`${base}/settings/public`).then((r) => r.data);
